var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_4348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 52.7048C42.4264 52.7048 52.5 42.6312 52.5 30.2048C52.5 17.7784 42.4264 7.70477 30 7.70477C17.5736 7.70477 7.5 17.7784 7.5 30.2048C7.5 42.6312 17.5736 52.7048 30 52.7048Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 32.7048C34.1421 32.7048 37.5 29.3469 37.5 25.2048C37.5 21.0626 34.1421 17.7048 30 17.7048C25.8579 17.7048 22.5 21.0626 22.5 25.2048C22.5 29.3469 25.8579 32.7048 30 32.7048Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4199 47.3273C16.0387 45.2678 17.3048 43.4627 19.0305 42.1797C20.7562 40.8967 22.8495 40.2041 24.9999 40.2048H34.9999C37.1531 40.204 39.2489 40.8983 40.9759 42.1842C42.7028 43.4702 43.9686 45.2792 44.5849 47.3423",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_4348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.204773)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.eed5f27fe00dd1a580920e4328204412.svg";
export { ForwardRef as ReactComponent };